import React from 'react';
import Menu from '../Components/Menu';

function Indonesia() {
  return (
    <div>
      <div>
        {/* Navbar & Hero Start */}
        <div className="container-fluid position-relative p-0">
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
            <div className="container py-5">
              <div className="row justify-content-center py-5">
                <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                  <h1 className="display-3 text-white animated slideInDown">
                    Indonesia
                  </h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                      <li className="breadcrumb-item">
                        <a href="#">Home</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a href="#">Destination</a>
                      </li>
                      <li
                        className="breadcrumb-item text-white active"
                        aria-current="page"
                      >
                        Indonesia
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Navbar & Hero End */}

        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Destination
          </h6>
          <h1 className="mb-5">5 famous tourist destinations in Indonesia</h1>
        </div>
      </div>
      <div className="container">
        <div className="content">
          <p>
            Indonesia is known as the "archipelago nation" with hundreds of
            thousands of islands, both large and small, contributing to the
            strong development of its tourism industry. In addition to beautiful
            islands, this country also features national parks and majestic,
            untouched volcanoes. Following Bách hóa XANH's footsteps, let's list
            10 incredible destinations that you must visit and explore right
            away!
          </p>
          <h3 className="text">1. Bali Archipelago</h3>
          <p>
            When mentioning Indonesia, you immediately think of the beautiful
            island of Bali! Just looking at it through the screen can already
            captivate your heart. It is the top choice for luxury resorts and a
            favorite destination for A-list celebrities worldwide.
          </p>
          <p>
            Indeed, the breathtaking scenery and romantic ambiance of Tanah Lot
            Temple have inspired many to write beautiful love stories. The
            serene surroundings, the charm of the land and sea, all contribute
            to creating a perfect setting for romantic tales to unfold. Many
            couples have chosen Tanah Lot as a backdrop for their love stories,
            capturing the essence of their romance amidst the enchanting beauty
            of the temple and its surroundings.
          </p>{' '}
          <p>
            Đảo Bali hội tụ đầy đủ các nét tinh hoa thuần túy của thiên nhiên,
            nước biển xanh trong vắt, những cánh đồng ruộng lúa xanh ngát cùng
            những công trình tôn giáo mang đậm bản sắc văn hóa Hindu địa phương.
          </p>
          <p>
            Bali Island indeed combines the pure essence of nature with its
            crystal-clear blue waters, verdant rice terraces, and distinctive
            religious structures that reflect the local Hindu culture. The
            island is a harmonious blend of stunning natural landscapes and rich
            cultural heritage. Visitors to Bali can immerse themselves in the
            beauty of pristine beaches, explore lush rice fields, and witness
            the intricate Hindu temples that are deeply rooted in the local
            traditions. It is this unique fusion of natural beauty and cultural
            significance that makes Bali a truly remarkable destination.
          </p>
          <center>
            <img src="img/indonesia1.jpg" alt="" />
          </center>{' '}
          <br /> <br />
          <h3 className="text">2. The Gili Islands</h3>
          <p>
            Located in the strait of Lombok, the Gili Islands are often referred
            to as the "Asian paradise" due to their pristine, untouched, and
            incredibly beautiful scenery. The islands boast pure natural beauty
            and a sense of serenity. The well-preserved ecological forests,
            exquisite emerald beaches, and extensive coral reefs contribute to
            the overall perfection of the destination. The Gili Islands are
            carefully conserved, ensuring the preservation of their enchanting
            charm and the protection of their marine ecosystems.
          </p>
          <p>
            The Gili Islands are an ideal destination for beach lovers, offering
            opportunities for exploration, swimming, and discovering fascinating
            experiences. The peak tourist season in this area is from July to
            September when the weather is clear, the sea is refreshing, and
            there is minimal rainfall or thunderstorms. Don't miss out on this
            perfect resort destination!
          </p>
          <center>
            <img src="img/indonesia2.jpg" alt="" />
          </center>{' '}
          <br /> <br />
          <h3 className="text">3. Mount Bromo</h3>
          <p>
            Located within the Bromo Tengger Semeru National Park, covering a
            vast area of approximately 800 km2, Mount Bromo is known as the most
            majestic mountain in Asia. Witnessing the sunrise at Mount Bromo is
            like experiencing "half of the beauty of nature." Standing atop the
            mountain and observing the first rays of light, the entire area is
            enveloped in a pristine white color, resembling drifting clouds. It
            is a breathtaking sight that no one would want to miss in their
            lifetime.
          </p>
          <center>
            <img src="img/indonesia3.jpg" alt="" />
          </center>{' '}
          <br /> <br />
          <h3 className="text">4. Borobudur Temple</h3>
          <p>
            Borobudur Temple, also known as Ba La Phù Đổ, is a Buddhist temple
            dating back to the 8th century, located in central Java, Indonesia.
            It is the only temple in the world with nine tiers, consisting of
            six square and three circular tiers adorned with 2,672 exquisitely
            carved relief panels and 504 Buddha statues, each depicting various
            postures and expressions.
          </p>
          <p>
            What makes Borobudur Temple truly special is that it is a colossal
            allegorical story of enlightenment. If you are a follower of
            Buddhism, you should not miss this destination. Here, you will
            experience the three levels of Buddhist teachings depicted through
            the relief panels: Kamadhatu (the world of desire), Rupadhatu (the
            world of forms), and Arupadhatu (the formless world). These levels
            symbolize different stages of spiritual development and provide
            profound insights into Buddhist philosophy and enlightenment.
          </p>
          <center>
            <img src="img/indonesia4.jpg" alt="" />
          </center>{' '}
          <br /> <br />
          <h3 className="text">5. Tanah Lot Temple</h3>
          <p>
            Tanah Lot Temple is the most famous temple in Bali and a popular
            spot for tourists to capture stunning photos. It is a place that
            combines prayer and a love for the ocean. The name "Tanah Lot" holds
            its own significance: "Tanah" means land and "Lot" means sea,
            symbolizing an island rising from the sea. This picturesque temple
            stands on a rocky outcrop, surrounded by the vast ocean, creating a
            mesmerizing sight that attracts visitors from around the world.
          </p>
          <p>
            As the most sacred place in Bali, any prayers made at Tanah Lot
            Temple are believed to come true. This belief attracts numerous
            tourists to the temple every year. Apart from its inherent spiritual
            significance, Tanah Lot Temple stands out for its unique
            construction, as it is built in the middle of the open sea. This
            distinctive design adds to the allure of the temple, creating a
            captivating and awe-inspiring experience for visitors.
          </p>
          <center>
            <img src="img/indonesia5.jpg" alt="" />
          </center>{' '}
          <br /> <br />
        </div>
      </div>
    </div>
  );
}

export default Indonesia;
